import React from "react";
import { AnimatePresence, motion } from "framer-motion";
export const AnimateHeight = ({ children, isOpen, duration = 0.3, useFade = true }) => {
    return (React.createElement(AnimatePresence, { initial: false }, isOpen && (React.createElement(motion.div, { initial: { height: 0, overflow: "hidden", opacity: useFade ? 0 : 1 }, animate: { height: "auto", opacity: 1 }, exit: { height: 0, overflow: "hidden", opacity: useFade ? 0 : 1 }, transition: { duration } }, children))));
};
